import React from "react";
import { Mail, MapPin, CheckCircle2 } from "lucide-react";
import HeroBackground from "@/components/HeroBackground";
import LeadForm from "@/components/LeadForm";
import FinalCTA from "@/components/FinalCTA";
import { useT } from "@/i18n";

export default function Contact() {
  const t = useT();
  return (
    <div>
      <section className="relative overflow-hidden">
        <HeroBackground />
        <div className="relative nx-container pt-16 md:pt-24 pb-12 md:pb-16">
          <div className="nx-mono text-xs uppercase tracking-[0.32em] text-[#38D8FF] mb-5 nx-fade-in">
            / {t.contactPage.eyebrow}
          </div>
          <h1 className="nx-heading text-5xl sm:text-6xl lg:text-7xl font-bold leading-tight max-w-4xl tracking-tight nx-fade-in">
            <span className="nx-gradient-text">{t.contactPage.title1}</span>
            <br />
            {t.contactPage.title2}
          </h1>
          <p className="mt-6 max-w-2xl text-lg text-white/75 leading-relaxed nx-fade-in">
            {t.contactPage.lede}
          </p>
        </div>
      </section>

      <section className="nx-container pb-24 md:pb-32 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4 space-y-8">
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-white/45 mb-3 nx-mono">
              / {t.contactPage.directHeading}
            </div>
            <a
              href="mailto:hello@nexora-technologies.eu"
              className="inline-flex items-center gap-2 text-white/85 hover:text-white"
            >
              <Mail className="w-4 h-4 text-[#38D8FF]" /> hello@nexora-technologies.eu
            </a>
            <div className="mt-3 inline-flex items-center gap-2 text-white/65 text-sm">
              <MapPin className="w-4 h-4 text-[#38D8FF]" /> {t.contactPage.addressList}
            </div>
          </div>

          <div className="nx-card rounded-2xl p-6">
            <div className="text-xs uppercase tracking-[0.2em] text-white/45 mb-4 nx-mono">
              / {t.contactPage.whatToExpectHeading}
            </div>
            <ul className="space-y-3 text-sm text-white/80">
              {t.contactPage.whatToExpectList.map((l) => (
                <li key={l} className="flex items-start gap-3">
                  <CheckCircle2 className="w-4 h-4 mt-0.5 text-[#38D8FF]" />
                  {l}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="lg:col-span-8">
          <LeadForm sourcePage="/contact" />
        </div>
      </section>

      <FinalCTA />
    </div>
  );
}
